<template>
  <v-dialog v-model="dialogs.privacyNotice" max-width="750px">
    <v-card style="" class="radius-20  ">
      <div class="text-right mt-2 mr-6 ">
        <span
          class="cursor-pointer fs24 mediumGrey"
          @click="dialogs.privacyNotice = false"
        >
          x
        </span>
      </div>
      <div
        style="overflow-y: scroll; height: 500px;"
        class="px-4 px-sm-12 darkBlue"
      >
        <p class="mb-6" :class="fontTitle">
          เอกสารแจ้งการประมวลผลข้อมูลส่วนบุคคล (Privacy Notice) สำหรับสมาชิก
          depa (depa Member)
        </p>
        <p class=" mb-8" :class="fontConntent">
          สำนักงานส่งเสริมเศรษฐกิจดิจิทัล (depa)
          มีการดำเนินการจัดเก็บข้อมูลส่วนบุคคลสำหรับขอรับการช่วยเหลือหรืออุดหนุน
          ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
          (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ ดังนั้น สำนักงานฯ
          จึงขอแจ้งให้สมาชิกทุกท่านทราบเกี่ยวกับวิธีการและวัตถุประสงค์ในการเก็บรวบรวม
          ใช้และเผยแพร่ข้อมูลส่วนบุคคล
          โดยสิทธิ์ในข้อมูลส่วนบุคคลของสมาชิกทุกท่าน
          จะอยู่ในความครอบครองของสำนักงานฯ และสำนักงานฯ
          จะประมวลผลข้อมูลส่วนบุคคล ด้วยความโปร่งใสชัดเจน
          สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562 สำนักงานฯ
          จึงขอให้สมาชิกโปรดอ่านเพื่อทำความเข้าใจถึงการประมวลผล
          และการคุ้มครองข้อมูลส่วนบุคคล ของสำนักงานฯ หากมีข้อสงสัยประการใดสามารถ
          ติดต่อสอบถามสำนักงานฯ
          ได้ตามรายละเอียดการติดต่อที่ปรากฏตามเอกสารฉบับนี้้
        </p>
        <div>
          <p class="mb-6" :class="fontSection">
            1. วัตถุประสงค์และการประมวลผลข้อมูล
          </p>
          <p class="mb-6" :class="fontConntent">
            <span :class="fontHead">การเก็บข้อมูลส่วนบุคคล :</span>
            สมาชิก depa
            จำเป็นต้องให้ข้อมูลส่วนบุคคลเพื่อระบุและใช้ในการยืนยันตัวตนสมาชิก
            เพื่อให้สมาชิกได้รับสิทธิ์ในการรับบริการ
            และสิทธิประโยชน์จากสำนักงานฯ ตามเงื่อนไขและบริการของสำนักงานฯ
            ทั้งนี้ข้อมูลต่างๆ ของสมาชิกจะมีส่วนช่วยให้สำนักงานฯ
            ใช้ในการวางและกำหนดนโยบายสำหรับมาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานฯ
            ได้
          </p>
          <div class="mb-6" :class="fontConntent">
            <p>
              <span :class="fontHead"> การประมวลผลข้อมูล : </span>
              สำนักงานฯ
              ดำเนินการประมวลผลข้อมูลส่วนบุคคลของสมาชิกภายใต้การประมวลผล
              ดังต่อไปนี้
            </p>

            <p>
              (1) สัญญา (Contract) เมื่อสมาชิกสมัครขอรับการช่วยเหลือหรืออุดหนุน
              ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานฯ
              สมาชิกจำเป็นต้องให้ข้อมูลส่วนบุคคลกับสำนักงานฯเพื่อนำข้อมูลส่วนบุคคลไปประมวลผล
              ที่เกี่ยวกับการให้บริการตามเงื่อนไขและข้อกำหนดตามมาตรการช่วยเหลือหรือการอุดหนุน
              ของสำนักงานฯ รวมทั้งใช้ในการติดต่อสื่อสาร ตอบขอซักถามของสมาชิก
              ทั้งนี้หากสมาชิกไม่ให้ข้อมูลส่วนบุคคลดังกล่าว
              จะส่งผลกระทบทำให้ไม่สามารถ ขอรับการช่วยเหลือหรืออุดหนุน
              ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานฯ ได้ และสำนักงานฯ
              ไม่สามารถจัดสิทธิหรือประโยชน์ตามเงื่อนไข ไม่สามารถติดต่อสื่อสาร
              ไม่สามารถตรวจสอบความสามารถในการเข้าทำสัญญา
              รวมถึงการตรวจสอบความเป็นตัวตนของสมาชิกได้ อันเป็นไปตามมาตรา 24 (3)
              ของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
            </p>

            <p>
              (2) ความยินยอม (Consent) สำนักงานฯ
              จะขอความยินยอมจากสมาชิกก่อนนำข้อมูลส่วนบุคคลของสมาชิกไปในใช้ในการประมวลผล
              เพื่อแจ้งหรือนำเสนอบริการ สิทธิ
              หรือประโยชน์ให้กับสมาชิกเฉพาะบุคคลกับสมาชิก
              หรือเพื่อเปิดเผยข้อมูลส่วนบุคคลของสมาชิกให้กับหน่วยงานร่วมดำเนินการอื่นๆ
              ของสำนักงานฯ
              เพื่อการยืนยันตัวตนและเชื่อมบัญชีสมาชิกภายใต้ข้อกำหนดการบริการของสำนักงานฯ
              ในการนี้
              สมาชิกมีความประสงค์จะเปลี่ยนแปลงความยินยอมสามารถเปลี่ยนแปลงได้ด้วยตัวสมาชิกเองในระบบสมาชิกของสำนักงานฯ
              หรือติดต่อสำนักงานฯ
              และแจ้งความประสงค์ได้ตามรายละเอียดเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
              (ข้อ 5)
            </p>
            <p>
              (3) อื่นๆ สำนักงานฯ
              อาจมีการนำข้อมูลส่วนบุคคลของสมาชิกไปใช้ในการประมวลผลเพื่อการจัดการ
              และการจัดทำรายงานของสำนักงานฯ
              สำหรับใช้ในการวางและกำหนดนโยบายสำหรับมาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานฯ
              หรือปฏิบัติภารกิจอื่น ๆ โดยชอบด้วยกฎหมายได้ ซึ่งเป็นไปตามมาตรา 24
              แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
            </p>
          </div>
        </div>
        <div>
          <p :class="fontSection">
            2. ข้อมูลส่วนบุคคลที่จะทำการประมวลผลและระยะเวลาในการเก็บรวบรวมข้อมูล
          </p>
          <p :class="fontConntent">
            <span :class="fontHead"> ประเภทหรือรายการข้อมูลส่วนบุคคล </span>
            <br />
            ประเภทหรือรายการข้อมูลส่วนบุคคล <br />
            - ข้อมูลที่ปรากฏตามหน้าบัตรประจำตัวประชาชน <br />
            - ข้อมูลพาสปอร์ต(Passport)<br />
            -
            ข้อมูลรายการขอรับบริการการช่วยเหลือหรืออุดหนุนภายใต้มาตรการช่วยเหลือหรือ
            การอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล (depa) <br />
            - ข้อมูลที่ได้รับจากการสอบถาม การให้ข้อคิดเห็น คำติชม คำถามของสมาชิก
          </p>

          <p :class="fontConntent">
            <span :class="fontHead"> ระยะเวลาในการเก็บรวบรวมข้อมูล </span>
            <br />
            90 วัน นับถัดจากวันสิ้นสุดความเป็นสมาชิก depa ทั้งนี้
            เมื่อพ้นกำหนดระยะเวลาข้างต้น สำนักงานฯ จะทำการลบ
            หรือทำให้ข้อมูลส่วนบุคคลไม่สามารถระบุตัวบุคคลของสมาชิกได้
            เว้นแต่มีเหตุจำเป็นที่ได้บัญญัติไว้เป็นสาระสำคัญตามกฎหมายอื่น
          </p>
        </div>
        <div>
          <p :class="fontSection">
            3. ประเภทของบุคคลหรือหน่วยงานซึ่งข้อมูลส่วนบุคคลอาจเปิดเผย
          </p>
          <p :class="fontConntent">
            สำนักงานฯ อาจทำการเปิดเผยข้อมูลส่วนบุคคลของสมาชิก
            ให้กับหน่วยร่วมดำเนินงานของสำนักงานฯ เช่น สมาคม
            หน่วยงานภายใต้สภาอุตสาหกรรม หน่วยงานภายใต้สภาหอการค้า มหาวิทยาลัย
            กลุ่มวิสาหกิจ บริษัทที่มีข้อตกลงกับสำนักงาน
            ผู้ประกอบการดิจิทัลที่ขึ้นทะเบียนกับสำนักงานฯ
            หน่วยงานตรวจสอบภายนอกจากหน่วยงานภาครัฐ
            หน่วยงานราชการตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
            กำหนด
          </p>
        </div>
        <div>
          <p :class="fontSection">4. สิทธิของเจ้าของข้อมูล</p>
          <p :class="fontConntent">
            (1) สิทธิในการเพิกถอนความยินยอมให้สำนักงานฯ
            ประมวลผลข้อมูลส่วนบุคคลของสมาชิก<br />
            (2) สิทธิในการเข้าถึงและรับสำเนาข้อมูลส่วนบุคคลที่สำนักงานฯ
            ได้เก็บรวบรวม ใช้ เปิดเผย <br />(3)
            สิทธิในการขอให้โอนย้ายข้อมูลส่วนบุคคลชองสมาชิก <br />(4)
            สิทธิในการคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผย
            ข้อมูลส่วนบุคคลของสมาชิก <br />(5) สิทธิในการขอให้ลบ ทำลาย
            หรือทำให้ข้อมูลส่วนบุคคลของสมาชิกเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูล
            ส่วนบุคคลนั้นได้ <br />(6)
            สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลของสมาชิกให้ถูกต้องเป็นปัจจุบัน
            สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด<br />
            (7) สิทธิในการที่จะร้องเรียนในกรณีที่สมาชิกเห็นว่าถูกสำนักงานฯ
            หรือเจ้าหน้าที่ หรือหน่วยร่วมดำเนินงานของสำนักงานฯ
            ละเมิดสิทธิตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
            การร้องขอใดๆ
            เพื่อการให้สิทธิของสมาชิกตามที่กล่าวข้างต้นจะต้องกระทำเป็นลายลักษณ์อักษร
            และสำนักงานฯ
            จะดำเนินการภายในระยะเวลาตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ.2562 กำหนดที่เกี่ยวกับสิทธิของสมาชิกในฐานะเจ้าของข้อมูลส่วนบุคคล
            ข้อจำกัดในการให้บริการกับสมาชิกในกรณีที่สมาชิกขอให้สำนักงานฯ ลบ
            ทำลายข้อมูล ระงับ ขอให้โอน การคัดค้าน
            หรือทำให้ข้อมูลไม่สามารถระบุตัวตนได้ หรือถอนความยินยอม
            อาจจะทำให้เกิดข้อจำกัดกับการดำเนินในการให้บริการของสำนักงานฯ
            กับสมาชิกบางกรณีได้
            ทั้งนี้ภายใต้ข้อกำหนดเงื่อนไขของการเป็นสมาชิกและตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วน
            บุคคล พ.ศ.2562 กำหนด
          </p>
        </div>
        <div>
          <p :class="fontSection">
            5. รายละเอียดเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
          </p>
          <p :class="fontConntent">
            หากมีเหตุร้องเรียนเกี่ยวกับข้อมูลส่วนบุคคลสามารถติดต่อประสานงานมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลได้ในช่องทางดังนี้
          </p>
          <p :class="fontHead">เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</p>
          <p :class="fontConntent" style="width:300px;">
            เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล<br />
            เลขที่ 80 ถนนลาดพร้าว ซอยลาดพร้าว 4 แขวงจอมพล เขตจตุจักร
            กรุงเทพมหานคร 10900<br />
            อีเมล์: doss@depa.or.th
            <br />
            โทรศัพท์: 0-2026-2333
          </p>
          <p :class="fontHead">ผู้คุ้มครองข้อมูลส่วนบุคคล</p>
          <p :class="fontConntent" style="max-width: 300px;">
            สำนักงานส่งเสริมเศรษฐกิจดิจิทัล (depa)<br />
            เลขที่ 80 ถนนลาดพร้าว ซอยลาดพร้าว 4 แขวงจอมพล เขตจตุจักร
            กรุงเทพมหานคร 10900 <br />อีเมล์: doss@depa.or.th<br />
            โทรศัพท์: 0-2026-2333
          </p>
          <p :class="fontConntent">
            หากสมาชิกเห็นว่าการประมวลผลข้อมูลส่วนบุคคลของสมาชิกไม่เป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ.2562 สมาชิกมีสิทธิที่จะร้องเรียนไปยังสำนักงานคณะกรรมการคุ้มครอง
            ข้อมูลส่วนบุคคล
          </p>
        </div>
      </div>
      <hr class=" hr ma-0 mediumGrey" />
      <div class="py-7">
        <div
          class="flex-all-center  px-5 px-sm-10"
          style="justify-content: space-evenly"
        >
          <Btn
            style="width:100%; max-width: 230px;"
            white
            text="ยกเลิก"
            radius="25"
            width="95%"
            height="40"
            fontSize="16"
            bold
            @click="dialogs.privacyNotice = false"
          />
          <Btn
            style="width:100%; max-width: 230px;"
            blue
            text="ถัดไป"
            radius="25"
            width="95%"
            height="40"
            fontSize="16"
            bold
            @click="next()"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialogs: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    dpSize: {
      deep: true,
      immediate: true,
      handler(dpSize) {
        if (dpSize === "xs") {
          this.fontTitle = "bold7 fs20";
          this.fontSection = "bold7 fs18";
          this.fontHead = "bold7 fs16";
          this.fontConntent = "bold5 fs16";
        } else {
          this.fontTitle = "bold7 fs24";
          this.fontSection = "bold7 fs20";
          this.fontHead = "bold7 fs18";
          this.fontConntent = "bold5 fs18";
        }
      },
    },
  },
  mounted() {},
  data() {
    return {
      fontTitle: "",
      fontSection: "",
      fontHead: "",
      fontConntent: "",
    };
  },
  computed: {
    dpSize() {
      return this.$store.state.dpSize;
    },
  },
  methods: {
    next() {
      this.dialogs.consent = true;
      this.dialogs.privacyNotice = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
